
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class OldFilmEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const dustCount = Math.floor(20 * (config.parallaxComplexity || 1.0));
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;
        ctx.strokeStyle = pc.color;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.15 / (layerIndex + 1);
             
             // Random dust spots
            for (let i = 0; i < dustCount; i++) {
                const rx = (this.pseudoRandom(i + Math.floor(time * 30)) - 0.5) * width * 3;
                const ry = (this.pseudoRandom(i + 100 + Math.floor(time * 30)) - 0.5) * height * 3;
                const s = (1 + this.pseudoRandom(i) * 3) * scale;
                ctx.fillRect(rx, ry, s, s);
            }
            
            // Vertical film scratches
            if (this.pseudoRandom(Math.floor(time * 10)) > 0.8) {
                const sx = (this.pseudoRandom(Math.floor(time * 10)) - 0.5) * width * 2;
                ctx.lineWidth = 0.5 * scale;
                ctx.beginPath();
                ctx.moveTo(sx, -height * 2);
                ctx.lineTo(sx, height * 2);
                ctx.stroke();
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
